import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { getImageSrc } from '../../../core/image-utilities';
import { TranslateService } from '@ngx-translate/core';
import { StatsApiService } from '../../../core/stats';
import { VitalMetricsTable } from './vital-metrics.interface';

@Component({
  selector: 'app-vital-metrics-card',
  templateUrl: './vital-metrics-card.component.html',
  styleUrls: ['./vital-metrics-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class VitalMetricsCardComponent {
  @Input() loading = false;
  @Input() isEmpty: boolean;
  @Input() isError: boolean;
  @Input() tableData: VitalMetricsTable;
  @Input() scoreAge: number;
  @Input() refreshing: boolean;
  @Output() learnButtonClicked = new EventEmitter();
  @Output() refreshButtonClicked = new EventEmitter();

  readonly cardConfig = {
    header: {
      title: { key: 'ANALYTICS.VITAL_METRICS_MODAL.TITLE' },
      subtitle: { key: 'ANALYTICS.VITAL_METRICS_MODAL.SUBTITLE' },
    },
  };

  refreshImage = getImageSrc('images/refresh.svg');

  constructor(
    private translateService: TranslateService,
    private statsApiService: StatsApiService,
  ) {}

  learnButtonEvent($event: MouseEvent): void {
    this.learnButtonClicked.emit($event);
  }

  refreshButtonEvent($event: MouseEvent): void {
    this.refreshButtonClicked.emit($event);
  }

  getScoreAgeText(): string {
    return this.statsApiService.getScoreAgeText(this.scoreAge);
  }
}
